import { getField, updateField } from 'vuex-map-fields';
import FormRequestAppointment from '../../api/form-request-appointment';

// initial state
const state = {
};

// getters
const getters = {
    getField
};

// actions
const actions = {
    postSubmitForm({ commit, rootState }, { data, dealerId, clientToken, cb }) {
        FormRequestAppointment.postSubmitForm((data) => {
            if (cb) {
                cb();
            }
        }, { data, dealerId, clientToken });
    },
};

// mutations
const mutations = {
    updateField,
    setStateValue(state, payload) {
        state[payload.key] = payload.value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
